import { Grid, Stack } from "@mui/material";
import TopSection from "../../../Components/Common/Top/TopSection";
import ActionHistoryList from "./ActionHistoryList";


const ActionHistory = () => {
  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              title="Action History"
            />
            <div class="container">
              {/* top table */}
              <ActionHistoryList/>
             
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default ActionHistory;

